import React, { useState } from "react";
import { Accordion, Card } from "react-bootstrap";
import { Button } from "react-bootstrap";
import * as uuid from "uuid";
import isEmpty from "lodash/isEmpty";
import GraduationForm from "./GraduationForm";
import ClassXIIForm from "./ClassXIIForm";
import ClassXForm from "./ClassXForm";
import OtherQualificationForm from "./OtherQualificationForm";
import {
  QUALIFICATION_TYPES,
  embeddedSpacesPattern
} from "../../constants/constants";
import { getQualificationDetails } from "../../util/candidateDataFilters";
import { qualificationObject } from "../../constants/candidateDataObjects";
import "../../styles/styles.css";

export const QualificationInfo = ({
  candidateId,
  qualificationDetails,
  addCandidateQualificationDetails,
  updateCandidateQualificationDetails,
  deleteCandidateQualificationDetails
}) => {
  const [activeKey, setActiveKey] = useState("0");
  const defaultQualificationDetails = qualificationObject();
  const userCertificationDetails = getQualificationDetails(
    QUALIFICATION_TYPES.CERTIFICATION,
    qualificationDetails
  );

  const handleOnChangeQualificationDetails = (
    { target: { name, value } },
    qualificationTypeID,
    qualificationDetails
  ) => {
    if (embeddedSpacesPattern.test(value)) {
      if (!isEmpty(qualificationDetails) && qualificationDetails.id) {
        updateCandidateQualificationDetails(
          qualificationDetails.id,
          name,
          value.trimStart()
        );
      } else {
        const defaultQualificationObj = qualificationObject();
        const newQualification = {
          ...defaultQualificationObj,
          id: `temp_${uuid.v4()}`,
          candidateId,
          qualificationId: qualificationTypeID,
          [name]: value.trimStart()
        };
        addCandidateQualificationDetails(newQualification);
      }
    }
  };
  const addNewCertificationForm = () => {
    addCandidateQualificationDetails({
      ...defaultQualificationDetails,
      id: `temp_${uuid.v4()}`,
      candidateId,
      qualificationId: QUALIFICATION_TYPES.CERTIFICATION
    });
    setActiveKey("4");
  };

  const addPostGraduationDetails = () => {
    addCandidateQualificationDetails({
      ...defaultQualificationDetails,
      id: `temp_${uuid.v4()}`,
      candidateId,
      qualificationId: QUALIFICATION_TYPES.POSTGRADUATION
    });
    setActiveKey("3");
  };
  const postGraduationDetails = getQualificationDetails(
    QUALIFICATION_TYPES.POSTGRADUATION,
    qualificationDetails
  );
  return (
    <div className="container w-100 h-100 mx-auto pt-3 mb-5 org-details">
      <Accordion
        key={activeKey}
        //activeKey={activeKey}
        defaultActiveKey={activeKey}
        className="qualification-details"
      >
        <Card>
          {/* {activeKey} */}
          <Accordion.Toggle
            as={Card.Header}
            eventKey="0"
            className="accordian-header"
            onClick={() => setActiveKey("0")}
          >
            Class X
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <ClassXForm
                qualificationTypeID={QUALIFICATION_TYPES.CLASSX}
                classXDetails={getQualificationDetails(
                  QUALIFICATION_TYPES.CLASSX,
                  qualificationDetails
                )}
                handleOnChangeQualificationDetails={
                  handleOnChangeQualificationDetails
                }
              />
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        <Card>
          <Accordion.Toggle
            as={Card.Header}
            eventKey="1"
            className="accordian-header"
            onClick={() => setActiveKey("1")}
          >
            Class XII / Intermediate
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="1">
            <Card.Body>
              <ClassXIIForm
                qualificationTypeID={QUALIFICATION_TYPES.CLASSXII}
                classXIIDetails={getQualificationDetails(
                  QUALIFICATION_TYPES.CLASSXII,
                  qualificationDetails
                )}
                handleOnChangeQualificationDetails={
                  handleOnChangeQualificationDetails
                }
              />
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        <Card>
          <Accordion.Toggle
            as={Card.Header}
            eventKey="2"
            className="accordian-header"
            onClick={() => setActiveKey("2")}
          >
            Graduation
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="2">
            <Card.Body>
              <GraduationForm
                qualificationTypeID={QUALIFICATION_TYPES.GRADUATION}
                graduationDetails={getQualificationDetails(
                  QUALIFICATION_TYPES.GRADUATION,
                  qualificationDetails
                )}
                handleOnChangeQualificationDetails={
                  handleOnChangeQualificationDetails
                }
                deleteCandidateQualificationDetails={
                  deleteCandidateQualificationDetails
                }
              />
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        {!!postGraduationDetails && !!postGraduationDetails.length && (
          <Card>
            <Accordion.Toggle
              as={Card.Header}
              eventKey="3"
              className="accordian-header"
              onClick={() => setActiveKey("3")}
            >
              Post Graduation
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="3">
              <Card.Body>
                <GraduationForm
                  qualificationTypeID={QUALIFICATION_TYPES.POSTGRADUATION}
                  graduationDetails={getQualificationDetails(
                    QUALIFICATION_TYPES.POSTGRADUATION,
                    qualificationDetails
                  )}
                  handleOnChangeQualificationDetails={
                    handleOnChangeQualificationDetails
                  }
                  deleteCandidateQualificationDetails={
                    deleteCandidateQualificationDetails
                  }
                />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        )}
        {!!userCertificationDetails.length && (
          <Card>
            <Accordion.Toggle
              as={Card.Header}
              eventKey="4"
              className="accordian-header"
              onClick={() => setActiveKey("4")}
            >
              Others
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="4">
              <Card.Body>
                {userCertificationDetails.map((certification, index) => (
                  <OtherQualificationForm
                    certificationDetails={certification}
                    index={index}
                    qualificationTypeID={QUALIFICATION_TYPES.CERTIFICATION}
                    updateCandidateQualificationDetails={
                      updateCandidateQualificationDetails
                    }
                    addCandidateQualificationDetails={
                      addCandidateQualificationDetails
                    }
                    deleteCandidateQualificationDetails={
                      deleteCandidateQualificationDetails
                    }
                    handleOnChangeQualificationDetails={
                      handleOnChangeQualificationDetails
                    }
                  />
                ))}
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        )}
        <div className="float-right">
          {isEmpty(postGraduationDetails) && (
            <Button
              variant="success"
              className="mb-3 mt-3"
              onClick={addPostGraduationDetails}
            >
              ADD POST GRADUATION
            </Button>
          )}
          <Button
            variant="success"
            className="ml-2 mb-3 mt-3"
            onClick={addNewCertificationForm}
          >
            {userCertificationDetails.length === 0
              ? "ADD CERTIFICATION"
              : "ADD ANOTHER CERTIFICATION"}
          </Button>
        </div>
      </Accordion>
    </div>
  );
};
export default QualificationInfo;
